module.exports = __webpack_public_path__ + "media/images/shark/Josh-f8b80522ee6413f483e4f980fcf67063.jpg";